enum fundIngAccountInstantVerificationActionType {
    FUNDING_ACCOUNT_INSTANT_VERIFICATION_LOAD_TOKEN = "FUNDING_ACCOUNT_INSTANT_VERIFICATION_LOAD_TOKEN"
}

export default fundIngAccountInstantVerificationActionType;